<template>
  <van-popup
    :class="['wallet-pay-success', layoutClass]"
    round
    v-model="show"
    @close="close"
  >
    <section class="wallet-wrapper">
      <div class="popup-header">
        <van-icon class="close-icon" name="cross" @click="close" />
        <p class="title">{{ $t('game.payment_success') }}</p>
        <p class="describe">
          <span
            v-for="item in describeList"
            :key="item.value"
            :class="item.class"
            >{{ item.value | formatNumber(region) }}</span
          >
        </p>
      </div>
      <div class="popup-content">
        <p class="title">{{ $t('game.sku_purchased_before') }}</p>
        <sku-info
          type="pay"
          :walletBalance="walletBalance"
          :realPayPrice="realPayPrice"
          :couponPayPrice="couponPayPrice"
          :detailChannelList="detailChannelList"
        />
        <p class="how-to-use">{{ $t('game.ask_if_go_on_purchasing') }}</p>
        <button @click="gotoPay">{{ $t('game.confirm_to_buy') }}</button>
      </div>
    </section>
  </van-popup>
</template>
<script>
  import { mapState } from 'vuex'
  import SkuInfo from './SkuInfo'
  import { queryOrder } from '@/api/order'
  import {
    storage,
    walletIsPaying,
    walletPayingSkuId,
    walletPayingOrder,
  } from '@/utils/storage'
  import { textFormat } from '@/utils/pluralRules.js'
  import { isNumber } from '@/utils/tool'
  import { TopLupe_WalletName } from '@/pages/Detail/config'
  import priceFormatMixins from '@/mixins/wallet/priceFormat'
  import {
    walletRechargePopup,
    walletRechargePopupClick,
  } from '@/pages/Detail/firebase.js'

  export default {
    name: 'wallet-pay-success',
    mixins: [priceFormatMixins],
    props: [
      'value',
      'walletBalance',
      'realPayPrice',
      'couponPayPrice',
      'detailChannelList',
    ],
    components: {
      SkuInfo,
    },
    data() {
      return {
        show: false,
        orderNo: this.$route.query.orderNo || '',
      }
    },
    computed: {
      ...mapState([
        'isDesktop',
        'isTurbo',
        'gameName',
        'selectedPaymentInfo',
        'region',
      ]),
      layoutClass() {
        return this.isDesktop ? 'pc' : this.isTurbo ? 'gt' : 'h5'
      },
      describeList() {
        const describe = textFormat(
          this.$t('game.current_balance'),
          this.walletBalance
        )
        return describe.split(' ').map((item) => {
          return {
            value: `${item} `,
            class: isNumber(item) ? 'money' : '',
          }
        })
      },
    },
    watch: {
      show(val) {
        if (val) {
          walletRechargePopup(this.gameName, 'recharge')
        }
      },
      selectedPaymentInfo(val) {
        if (val) {
          // 如果状态是在充值中，则查询支付状态
          if (
            storage.get(walletIsPaying) &&
            storage.get(walletPayingOrder) === this.orderNo &&
            storage.get(`${walletPayingSkuId}-${this.gameName}`) ===
              this.selectedPaymentInfo.skuId &&
            this.selectedPaymentInfo.payMethodName === TopLupe_WalletName
          ) {
            this.getOrderStatus()
          }
        }
      },
    },
    mounted() {},
    methods: {
      close() {
        this.removePayingFromStorage()
        this.show = false
      },
      gotoPay() {
        // 确认购买
        this.removePayingFromStorage()
        walletRechargePopupClick(this.gameName, 'recharge')
        this.show = false
        this.$emit('gotoPay')
      },
      removePayingFromStorage() {
        storage.remove(walletIsPaying)
        storage.remove(walletPayingOrder)
        storage.remove(`${walletPayingSkuId}-${this.gameName}`)
      },
      getOrderStatus() {
        this.show = false
        // 有订单好号，并且当前选中支付方式的是钱包
        if (this.orderNo) {
          // 查询支付状态，只查询一次
          queryOrder({ orderNo: this.orderNo }).then((response) => {
            const { orderStatus } = response
            if (orderStatus * 1 === 10) {
              // 支付成功展示
              this.show = true
            } else {
              // pending或支付失败，跳转到支付结果页继续查询
              this.removePayingFromStorage()
              this.$router_push({
                path: `/pay-result`,
                query: this.$route.query,
              })
            }
          })
        }
      },
    },
  }
</script>
<style scoped lang="scss" src="./RechargeGuideBySuccess.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './RechargeGuideBySuccess_pc.scss';
  }
</style>
